import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const Contact = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Contacto
        </Typography>
        <Typography variant="body1" paragraph>
          ¿Tienes alguna pregunta o necesitas ayuda? Estamos aquí para ayudarte.
        </Typography>
        <Typography variant="body1">
          Email: contacto@jooru.com
        </Typography>
        <Typography variant="body1">
          Teléfono: +1 (555) 123-4567
        </Typography>
      </Box>
    </Container>
  );
};

export default Contact;